export function saveDatosHelpdesk(datosHelpdesk) {
  return function (dispatch) {
    dispatch({
      type: "SAVE_DATOS_HELPDESK",
      payload: {
        datosHelpdesk: datosHelpdesk
      }
    })
  }
}